module.exports = __webpack_public_path__ + "img/block-magenta.9dc30789.webp";